/**
 * Helpers pour gérer les prix en centimes
 */

/**
 * Convertit un prix en euros en centimes
 */
export const eurosToCents = (euros: number): number => {
  return Math.round(euros * 100);
};

/**
 * Convertit un prix en centimes en euros
 */
export const centsToEuros = (cents: number): number => {
  return cents / 100;
};

/**
 * Formate un prix en centimes pour l'affichage (sans symbole €)
 */
export const formatCentsToEuros = (cents: number): string => {
  return (cents / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Parse un prix qui peut être string ou number et retourne des centimes
 */
export const parsePrice = (price: string | number): number => {
  if (typeof price === 'string') {
    // Si c'est une string, on considère que c'est en euros
    return Math.round(parseFloat(price) * 100);
  }
  // Si c'est déjà un number, on suppose que c'est en centimes
  return Math.round(price);
};

/**
 * Formate un prix pour l'affichage avec le symbole €
 * Exemple: 1234567 centimes → "12 345,67 €"
 */
export const formatPrice = (cents: number): string => {
  return `${formatCentsToEuros(cents)} €`;
};

/**
 * Calcule le total HT d'une ligne
 */
export const calculateLineHt = (quantity: number, unitPriceCents: number): number => {
  return Math.round(quantity * unitPriceCents);
};

/**
 * Calcule la TVA d'un montant HT
 */
export const calculateVat = (htCents: number, vatRate: number): number => {
  return Math.round(htCents * vatRate / 100);
};

/**
 * Calcule le TTC à partir du HT et du taux de TVA
 */
export const calculateTtc = (htCents: number, vatRate: number): number => {
  const vat = calculateVat(htCents, vatRate);
  return htCents + vat;
};